/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import {
    Checkbox,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    IconButton,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    Stack,
    TextField,
    Autocomplete,
    Chip
} from '@mui/material';
import { Box } from '@mui/system';
import { ErrorMessage, Field } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { gridSpacing, roles } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';
import { countyList, schoolData, streetTypes } from './data/listing_data';
import { tips } from './HelpData';
import HelpIcon from './HelpIcon';

import { useTheme } from '@emotion/react';
import { LoadingButton } from '@mui/lab';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import axiosServices from 'utils/axios';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const listingAgreementDocOptions = ['TXR', 'Other'];
const schoolDistrictOptions = [
    'Comal ISD',
    'La Vernia ISD',
    'Luling ISD',
    'Marion ISD',
    'Navarro ISD',
    'New Braunfels ISD',
    'Nixon-Smiley Cons ISD',
    'Prairie Lea ISD',
    'San Marcos ISD',
    'Schertz-Cibolo-Universal ISD',
    'Seguin ISD'
];

const femaFloodPlainOptions = ['No', 'Partial', 'Yes-100 yr', 'Yes-500 yr', 'See Remarks'];
const elementaryOptions = ['No', 'Partial', 'Yes-100 yr', 'Yes-500 yr', 'See Remarks'];
const middleJuniorOptions = ['No', 'Partial', 'Yes-100 yr', 'Yes-500 yr', 'See Remarks'];
const highSchoolOptions = ['No', 'Partial', 'Yes-100 yr', 'Yes-500 yr', 'See Remarks'];

const Listing = ({ inputFocusRef, role, errors, handleChange, handleBlur, values, touched, setFieldValue, setDataSaved }) => {
    const [openOptional, setOpenOptional] = useState(true);
    const [complexList, setComplexList] = useState([]);

    // Fetch the list of complexes from your backend API
    useEffect(() => {
        const fetchComplexes = async () => {
            try {
                const { data } = await axiosServices.get('/complex', {
                    headers: {
                        authorization: `Bearer ${localStorage.getItem('serviceToken')}`
                    },
                    params: {
                        limit: 10000
                    }
                });
                // Assuming your backend returns { complexes: [...] }
                setComplexList(data.complexes || []);
            } catch (error) {
                toast.error('Error fetching complex list');
            }
        };

        fetchComplexes();
    }, []);

    const handleToggle = () => {
        setOpenOptional((prev) => !prev);
    };
    const theme = useTheme();
    const { singleListing } = useSelector((state) => state.listings);
    const [selectedDate, setSelectedDate] = useState(null);
    const [dateError, setDateError] = useState(false);

    const handleDateChange = (newValue) => {
        setSelectedDate(newValue);
        setDateError(false);
    };

    const isApproved = useMemo(() => {
        const foundStatus = singleListing?.approvals?.find((item) => item?.status?.toLowerCase() === 'approved');
        return !!foundStatus;
    }, [singleListing]);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openTwo, setOpenTwo] = React.useState(false);
    const [unitNm, setUnitNm] = useState(null);

    const handleOpenTwo = () => {
        setOpen(false);
        setOpenTwo(true);
    };
    const handleCloseTwo = () => setOpenTwo(false);

    const handleUnitNumberChange = (handleChange) => {
        handleOpen();
    };

    const [loading, setLoading] = useState(false);

    const handleDuplicate = async () => {
        try {
            setDataSaved();
            setLoading(true);
            const { data: returnedData } = await axiosServices.post(`property/leaseAndDuplicate`, {
                leaseDate: selectedDate,
                property_id: singleListing.id,
                unit: unitNm
            });

            if (returnedData?.length === 2) {
                window.open(`/listing/${returnedData[1].id}`, '_self');
                toast.success('Listing has been duplicated successfully');
            } else {
                toast.error('Error duplicating listing');
            }
            setOpenTwo(false);
            setLoading(false);
        } catch (error) {
            toast.error('Something went wrong');
            console.error(error);
            setLoading(false);
        }
    };

    const [adminClicked, setAdminClicked] = useState(false);

    return (
        <>
            <div>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                    sx={{
                        '& .MuiPaper-root': {
                            width: '400px'
                        }
                    }}
                >
                    {open && (
                        <>
                            <DialogContent>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        Kindly confirm whether the previous unit has been leased.
                                    </Typography>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions sx={{ pr: 2.5 }}>
                                <Button
                                    sx={{ color: theme.palette.error.dark }}
                                    autoFocus
                                    onClick={() => {
                                        if (role === 'ADMIN') setAdminClicked(true);
                                        handleClose();
                                    }}
                                    color="secondary"
                                >
                                    No
                                </Button>
                                <LoadingButton type="button" variant="contained" size="small" onClick={handleOpenTwo} autoFocus>
                                    Yes
                                </LoadingButton>
                            </DialogActions>
                        </>
                    )}
                </Dialog>
            </div>
            <div>
                <Dialog
                    open={openTwo}
                    onClose={handleCloseTwo}
                    aria-labelledby="responsive-dialog-title"
                    sx={{
                        '& .MuiPaper-root': {
                            width: '400px'
                        }
                    }}
                >
                    {openTwo && (
                        <>
                            <DialogContent>
                                <DialogContentText>
                                    <Typography variant="body2" component="span" sx={{ mb: 2 }}>
                                        Would you like to archive the old unit listing and duplicate it for a new unit? If so, please
                                        provide the date when the previous unit was leased.
                                    </Typography>
                                    <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
                                        <Typography variant="h4" component="span" aria-required>
                                            Lease Date <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                        <DatePicker
                                            sx={{ mt: '5px !important' }}
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            disableFuture
                                            slotProps={{
                                                textField: {
                                                    error: dateError,
                                                    helperText: dateError ? 'Date is required' : ''
                                                }
                                            }}
                                        />
                                    </Stack>
                                    <TextField
                                        value={unitNm}
                                        onChange={(e) => setUnitNm(e.target.value)}
                                        sx={{ mt: 1 }}
                                        placeholder="Enter New Unit Number"
                                        required
                                        fullWidth
                                    />
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions sx={{ pr: 2.5 }}>
                                <Button sx={{ color: theme.palette.error.dark }} onClick={handleCloseTwo} color="secondary">
                                    No
                                </Button>
                                <LoadingButton
                                    type="button"
                                    variant="contained"
                                    size="small"
                                    onClick={handleDuplicate}
                                    autoFocus
                                    loading={loading}
                                    disabled={!selectedDate || !unitNm}
                                >
                                    Yes
                                </LoadingButton>
                            </DialogActions>
                        </>
                    )}
                </Dialog>
            </div>

            {/* // Main Form Started //  */}
            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12} sx={{ mt: 0 }}>
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                                mb: 2
                            }}
                        >
                            Complex Details
                        </Typography>
                        <SubCard>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Complex Name
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon
                                            title={tips?.complexName.title}
                                            ruleHelp={tips?.complexName.ruleHelp}
                                            generalHelpDesc={tips?.complexName.generalHelpDesc}
                                        />
                                    </Box>

                                    <Autocomplete
                                        id="complex"
                                        options={complexList} // an array of objects like [{ id: 'abc', name: 'Complex A' }, ...]
                                        getOptionLabel={(option) => option.name}
                                        value={values.complex_id ? complexList.find((c) => c.id === values.complex_id) || null : null}
                                        onChange={(event, newValue) => {
                                            // Save both complex id and name into Formik values
                                            setFieldValue('complex_id', newValue ? newValue.id : '');
                                            setFieldValue('complexName', newValue ? newValue.name : '');
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="complexName"
                                                variant="outlined"
                                                error={touched.complexName && Boolean(errors.complexName)}
                                                helperText={touched.complexName && errors.complexName}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Units in Complex
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon
                                            title={tips?.unitsInComplex.title}
                                            ruleHelp={tips?.unitsInComplex.ruleHelp}
                                            generalHelpDesc={tips?.unitsInComplex.generalHelpDesc}
                                        />
                                    </Box>

                                    <Field
                                        as={TextField}
                                        fullWidth
                                        required
                                        name="unitsInComplex"
                                        variant="outlined"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.unitsInComplex}
                                        error={touched.unitsInComplex && errors.unitsInComplex}
                                        helperText={<ErrorMessage name="unitsInComplex" />}
                                    />

                                    {/* {touched.unitsInComplex && errors.unitsInComplex && (
                                            <FormHelperText error>{errors.unitsInComplex}</FormHelperText>
                                        )} */}
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Floor Plan Name/Number
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon
                                            title={tips?.floorPlanName.title}
                                            ruleHelp={tips?.floorPlanName.ruleHelp}
                                            generalHelpDesc={tips?.floorPlanName.generalHelpDesc}
                                        />
                                    </Box>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        required
                                        name="floorPlanName"
                                        variant="outlined"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.floorPlanName}
                                        error={touched.floorPlanName && errors.floorPlanName}
                                        helperText={<ErrorMessage name="floorPlanName" />}
                                    />

                                    {/* {touched.floorPlanName && errors.floorPlanName && (
                                            <FormHelperText error>{errors.floorPlanName}</FormHelperText>
                                        )} */}
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                                mb: 2
                            }}
                        >
                            Listing Information
                        </Typography>
                        <SubCard>
                            <Grid container spacing={2}>
                                {role === roles.ADMIN && (
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControl
                                                required
                                                error={touched.listingAgreement && Boolean(errors.listingAgreement)}
                                                component="fieldset"
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel component="legend" sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Listing Agreement
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.listingAgreement?.title}
                                                        ruleHelp={tips?.listingAgreement?.ruleHelp}
                                                        generalHelpDesc={tips?.listingAgreement?.generalHelpDesc}
                                                    />
                                                </Box>
                                                <RadioGroup
                                                    aria-label="listing-agreement"
                                                    name="listingAgreement"
                                                    value={values.listingAgreement}
                                                    onChange={handleChange}
                                                    row
                                                    sx={{ gap: 1, ml: 1, mt: 1 }}
                                                >
                                                    {/* Exclusive Agency */}
                                                    <FormControlLabel
                                                        value="Exclusive Agency"
                                                        control={<Radio />}
                                                        label="Exclusive Agency"
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px'
                                                        }}
                                                    />

                                                    {/* Exclusive Right To Lease */}
                                                    <FormControlLabel
                                                        value="Exclusive Right To Lease"
                                                        control={<Radio />}
                                                        label="Exclusive Right To Lease"
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px',
                                                            justifyContent: 'center'
                                                        }}
                                                    />

                                                    {/* Property Management */}
                                                    <FormControlLabel
                                                        value="Property Management"
                                                        control={<Radio />}
                                                        label="Property Management"
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px'
                                                        }}
                                                    />
                                                </RadioGroup>

                                                {touched.listingAgreement && errors.listingAgreement && (
                                                    <Typography color="error" variant="body2">
                                                        {errors.listingAgreement}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl
                                            required
                                            error={touched.housingVouchers && Boolean(errors.housingVouchers)}
                                            component="fieldset"
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel component="legend" sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Housing Vouchers
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.housingVouchersYNHelp?.title}
                                                    ruleHelp={tips?.housingVouchersYNHelp?.ruleHelp}
                                                    generalHelpDesc={tips?.housingVouchersYNHelp?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <RadioGroup
                                                aria-label="housing-vouchers"
                                                name="housingVouchers"
                                                value={values.housingVouchers}
                                                onChange={handleChange}
                                                row
                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                            >
                                                {/* Yes */}
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={<Radio />}
                                                    label="Yes"
                                                    sx={{
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        padding: '2px 14px',
                                                        minWidth: '120px'
                                                    }}
                                                />

                                                {/* No */}
                                                <FormControlLabel
                                                    value="No"
                                                    control={<Radio />}
                                                    label="No"
                                                    sx={{
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        padding: '2px 14px',
                                                        minWidth: '120px',
                                                        justifyContent: 'center'
                                                    }}
                                                />
                                            </RadioGroup>

                                            {touched.housingVouchers && errors.housingVouchers && (
                                                <Typography color="error" variant="body2">
                                                    {errors.housingVouchers}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {role === roles.ADMIN && (
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControl
                                                required
                                                error={touched.listingAgreementDoc && Boolean(errors.listingAgreementDoc)}
                                                component="fieldset"
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel component="legend" sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Listing Agreement Doc
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.listingAgreementDocumentHelp?.title}
                                                        ruleHelp={tips?.listingAgreementDocumentHelp?.ruleHelp}
                                                        generalHelpDesc={tips?.listingAgreementDocumentHelp?.generalHelpDesc}
                                                        sx={{ ml: 1 }}
                                                    />
                                                </Box>

                                                <RadioGroup
                                                    aria-label="listing-agreement-doc"
                                                    name="listingAgreementDoc"
                                                    value={values.listingAgreementDoc}
                                                    onChange={handleChange}
                                                    row
                                                    sx={{ gap: 1, ml: 1, mt: 1 }}
                                                >
                                                    {listingAgreementDocOptions.map((option) => (
                                                        <FormControlLabel
                                                            key={option}
                                                            value={option}
                                                            control={<Radio />}
                                                            label={option}
                                                            sx={{
                                                                border: '1px solid #ccc',
                                                                borderRadius: '5px',
                                                                padding: '2px 14px',
                                                                minWidth: '180px'
                                                            }}
                                                        />
                                                    ))}
                                                </RadioGroup>

                                                {touched.listingAgreementDoc && errors.listingAgreementDoc && (
                                                    <Typography color="error" variant="body2">
                                                        {errors.listingAgreementDoc}
                                                    </Typography>
                                                )}
                                            </FormControl>

                                            {/* Help Icon */}
                                        </Box>
                                    </Grid>
                                )}
                                {role === roles.ADMIN && (
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                            <FormControl fullWidth error={touched.listingId && Boolean(errors.listingId)}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Listing ID
                                                    </Typography>
                                                </FormLabel>

                                                <Field
                                                    as={TextField}
                                                    name="listingId"
                                                    required
                                                    variant="outlined"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.listingId}
                                                    error={touched.listingId && Boolean(errors.listingId)}
                                                    helperText={<ErrorMessage name="listingId" />}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                )}

                                {/* {role === roles.ADMIN && (
                                    <Grid item xs={12} sm={5.6}>
                                        <Box sx={{ display: 'flex' }}>
                                            <Field
                                                as={TextField}
                                                fullWidth
                                                name="listingId"
                                                label="Listing ID"
                                                variant="outlined"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.listingId}
                                                error={touched.listingId && errors.listingId}
                                                helperText={<ErrorMessage name="listingId" />}
                                            />
                                        </Box>
                                    </Grid>
                                )} */}
                                {/* <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex' }}>
                                <FormControl fullWidth required error={touched.listingService && Boolean(errors.listingService)}>
                                    <InputLabel id="listing-service-label">Listing Service</InputLabel>
                                    <Select
                                        labelId="listing-service-label"
                                        id="listingService"
                                        name="listingService"
                                        value={values.listingService}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Listing Service"
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="Full Service">Full Service</MenuItem>
                                        <MenuItem value="Limited Service">Limited Service</MenuItem>
                                    </Select>
                                    {touched.listingService && errors.listingService && (
                                        <FormHelperText>{errors.listingService}</FormHelperText>
                                    )}
                                </FormControl>
                                <HelpIcon
                                    title={tips?.listingAgreement.title}
                                    ruleHelp={tips?.listingAgreement.ruleHelp}
                                    generalHelpDesc={tips?.listingAgreement.generalHelpDesc}
                                />
                            </Box>
                        </Grid> */}

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'end' }}>
                                        <FormControl fullWidth required error={touched.listPrice && Boolean(errors.listPrice)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Listing Price
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.listPriceHelp.title}
                                                    ruleHelp={tips?.listPriceHelp.ruleHelp}
                                                    generalHelpDesc={tips?.listPriceHelp.generalHelpDesc}
                                                    sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                fullWidth
                                                required
                                                type="number"
                                                name="listPrice"
                                                variant="outlined"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                onWheel={(e) => e.target.blur()}
                                                value={values.listPrice}
                                                error={touched.listPrice && errors.listPrice}
                                                helperText={<ErrorMessage name="listPrice" />}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>
                                {/* <Box sx={{ display: 'flex' }}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            type="number"
                                            name="listPrice"
                                            label="List Price"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onWheel={(e) => e.target.blur()}
                                            value={values.listPrice}
                                            error={touched.listPrice && errors.listPrice}
                                            helperText={<ErrorMessage name="listPrice" />}
                                        />
                                        <HelpIcon
                                            title={tips?.listPriceHelp.title}
                                            ruleHelp={tips?.listPriceHelp.ruleHelp}
                                            generalHelpDesc={tips?.listPriceHelp.generalHelpDesc}
                                        />
                                    </Box> */}

                                {/* <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex' }}>
                                <FormControl
                                    fullWidth
                                    required
                                    error={touched.specialListingConditions && Boolean(errors.specialListingConditions)}
                                >
                                    <InputLabel>Special Listing Conditions</InputLabel>
                                    <Select
                                        label="Special Listing Conditions"
                                        multiple
                                        value={values.specialListingConditions}
                                        onChange={(event) => {
                                            setFieldValue('specialListingConditions', event.target.value);
                                        }}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput label="Special Listing Conditions" />}
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        {specialListingConditionsOptions.map((option) => (
                                            <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                <Checkbox checked={values.specialListingConditions.includes(option)} />

                                                <ListItemText primary={option} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {touched.specialListingConditions && errors.specialListingConditions && (
                                        <FormHelperText>{errors.specialListingConditions}</FormHelperText>
                                    )}
                                </FormControl>
                                <HelpIcon title={tips.title} ruleHelp={tips.ruleHelp} generalHelpDesc={tips.generalHelpDesc} />
                            </Box>
                        </Grid> */}

                                {role === roles.ADMIN && (
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'end' }}>
                                            <FormControl
                                                fullWidth
                                                required
                                                error={touched.expirationDate && Boolean(errors.expirationDate)}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Expiration Date
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.expirationDateHelp?.title}
                                                        ruleHelp={tips?.expirationDateHelp?.ruleHelp}
                                                        generalHelpDesc={tips?.expirationDateHelp?.generalHelpDesc}
                                                        sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}
                                                    />
                                                </Box>

                                                <DatePicker
                                                    required
                                                    label="Expiration Date"
                                                    value={values.expirationDate}
                                                    onChange={(newValue) => {
                                                        setFieldValue('expirationDate', newValue);
                                                    }}
                                                    sx={{ width: '100%' }}
                                                    onBlur={handleBlur}
                                                    slotProps={{
                                                        textField: {
                                                            variant: 'outlined',
                                                            error: Boolean(touched.expirationDate && errors.expirationDate),
                                                            helperText:
                                                                touched.expirationDate && errors.expirationDate
                                                                    ? 'Expiration Date is Required'
                                                                    : ''
                                                        }
                                                    }}
                                                />

                                                {/* {touched.expirationDate && errors.expirationDate && (
                                                    <Typography color="error" variant="body2">
                                                        {errors.expirationDate}
                                                    </Typography>
                                                )} */}
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                )}

                                {/* <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex' }}>
                                <TextField
                                    fullWidth
                                    label="Auction Date"
                                    name="auctionDate"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={values.auctionDate}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <HelpIcon title={tips.title} ruleHelp={tips.ruleHelp} generalHelpDesc={tips.generalHelpDesc} />
                            </Box>
                            {touched.auctionDate && errors.auctionDate && <FormHelperText error>{errors.auctionDate}</FormHelperText>}
                        </Grid> */}
                            </Grid>
                        </SubCard>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                                mb: 2
                            }}
                        >
                            Location Information
                        </Typography>
                        <SubCard>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.streetNumber && Boolean(errors.streetNumber)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Street Number
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.streetNumber?.title}
                                                    ruleHelp={tips?.streetNumber?.ruleHelp}
                                                    generalHelpDesc={tips?.streetNumber?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>
                                            <Field
                                                as={TextField}
                                                name="streetNumber"
                                                variant="outlined"
                                                value={values.streetNumber}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="streetNumber" />}
                                                error={touched.streetNumber && Boolean(errors.streetNumber)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.streetName && Boolean(errors.streetName)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Street Name
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.streetName?.title}
                                                    ruleHelp={tips?.streetName?.ruleHelp}
                                                    generalHelpDesc={tips?.streetName?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                name="streetName"
                                                variant="outlined"
                                                value={values.streetName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="streetName" />}
                                                error={touched.streetName && Boolean(errors.streetName)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.unitNumber && Boolean(errors.unitNumber)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Unit Number
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.unitNumber?.title}
                                                    ruleHelp={tips?.unitNumber?.ruleHelp}
                                                    generalHelpDesc={tips?.unitNumber?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                name="unitNumber"
                                                variant="outlined"
                                                value={values.unitNumber}
                                                onChange={
                                                    role === 'ADMIN' && adminClicked
                                                        ? handleChange
                                                        : isApproved
                                                        ? () => {
                                                              handleUnitNumberChange(handleChange);
                                                          }
                                                        : handleChange
                                                }
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="unitNumber" />}
                                                error={touched.unitNumber && Boolean(errors.unitNumber)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.city && Boolean(errors.city)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        City
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.city?.title}
                                                    ruleHelp={tips?.city?.ruleHelp}
                                                    generalHelpDesc={tips?.city?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                name="city"
                                                variant="outlined"
                                                value={values.city}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="city" />}
                                                error={touched.city && Boolean(errors.city)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.state && Boolean(errors.state)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        State
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.state?.title}
                                                    ruleHelp={tips?.state?.ruleHelp}
                                                    generalHelpDesc={tips?.state?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                name="state"
                                                variant="outlined"
                                                value={values.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="state" />}
                                                error={touched.state && Boolean(errors.state)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.country && Boolean(errors.country)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Country
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.country?.title}
                                                    ruleHelp={tips?.country?.ruleHelp}
                                                    generalHelpDesc={tips?.country?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                name="country"
                                                variant="outlined"
                                                value={values.country}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="country" />}
                                                error={touched.country && Boolean(errors.country)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {/* <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex' }}>
                                <TextField
                                    fullWidth
                                    label="County"
                                    name="county"
                                    required
                                    value={values.county}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </Box>
                            {touched.county && errors.county && <FormHelperText error>{errors.county}</FormHelperText>}
                        </Grid> */}

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.zipCode && Boolean(errors.zipCode)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Zip Code
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.zipCode?.title}
                                                    ruleHelp={tips?.zipCode?.ruleHelp}
                                                    generalHelpDesc={tips?.zipCode?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Field
                                                as={TextField}
                                                name="zipCode"
                                                variant="outlined"
                                                value={values.zipCode}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="zipCode" />}
                                                error={touched.zipCode && Boolean(errors.zipCode)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={11.6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl fullWidth required error={touched.Subdivision && Boolean(errors.Subdivision)}>
                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Subdivision
                                                </Typography>
                                            </FormLabel>

                                            <Field
                                                as={TextField}
                                                name="Subdivision"
                                                variant="outlined"
                                                value={values.Subdivision}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={<ErrorMessage name="Subdivision" />}
                                                error={touched.Subdivision && Boolean(errors.Subdivision)}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormControl
                                            fullWidth
                                            required
                                            error={touched.streetTypeOrSuffix && Boolean(errors.streetTypeOrSuffix)}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Street Type/ Suffix
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.streetDirSuffix?.title}
                                                    ruleHelp={tips?.streetDirSuffix?.ruleHelp}
                                                    generalHelpDesc={tips?.streetDirSuffix?.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Autocomplete
                                                id="streetTypeOrSuffix"
                                                name="streetTypeOrSuffix"
                                                options={streetTypes}
                                                value={values.streetTypeOrSuffix || ''}
                                                // onChange={handleChange}
                                                onChange={(event, newValue) => {
                                                    // Update Formik value
                                                    setFieldValue('streetTypeOrSuffix', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                // input={<OutlinedInput />}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        error={touched.streetTypeOrSuffix && Boolean(errors.streetTypeOrSuffix)}
                                                    />
                                                )}
                                            />
                                            {touched.streetTypeOrSuffix && errors.streetTypeOrSuffix && (
                                                <FormHelperText>{errors.streetTypeOrSuffix}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {/* <Grid item xs={12} sx={{ mt: 2 }}>
                            <SubCard title="Other Location Information">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex' }}>
                                            <TextField
                                                fullWidth
                                                label="Out of State County"
                                                name="outOfStateCounty"
                                                value={values.outOfStateCounty}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <HelpIcon
                                                title={tips.outOfStateCounty.title}
                                                ruleHelp={tips.outOfStateCounty.ruleHelp}
                                                generalHelpDesc={tips.outOfStateCounty.generalHelpDesc}
                                            />
                                        </Box>
                                        {touched.outOfStateCounty && errors.outOfStateCounty && (
                                            <FormHelperText error>{errors.outOfStateCounty}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex' }}>
                                            <TextField
                                                fullWidth
                                                label="Out of State City"
                                                name="OutOfStateCity"
                                                value={values.OutOfStateCity}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <HelpIcon
                                                title={tips.outOfStateCity.title}
                                                ruleHelp={tips.outOfStateCity.ruleHelp}
                                                generalHelpDesc={tips.outOfStateCity.generalHelpDesc}
                                            />
                                        </Box>
                                        {touched.OutOfStateCity && errors.OutOfStateCity && (
                                            <FormHelperText error>{errors.OutOfStateCity}</FormHelperText>
                                        )}
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid> */}
                            </Grid>
                        </SubCard>
                        {role === roles.ADMIN && (
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        color: '#919191',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        lineHeight: 'normal',
                                        textTransform: 'capitalize',
                                        mb: 2
                                    }}
                                >
                                    Tax Information
                                </Typography>
                                <SubCard>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                    error={touched.taxLegalDescription && Boolean(errors.taxLegalDescription)}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Tax Legal Description
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.taxLegalDescription?.title}
                                                            ruleHelp={tips?.taxLegalDescription?.ruleHelp}
                                                            generalHelpDesc={tips?.taxLegalDescription?.generalHelpDesc}
                                                            sx={{ ml: 1, cursor: 'pointer', color: 'gray' }}
                                                        />
                                                    </Box>

                                                    <Field
                                                        as={TextField}
                                                        name="taxLegalDescription"
                                                        variant="outlined"
                                                        placeholder="Example: Lot 12 Of Block 45 Of Tract 3002 Of The City Of San Dunes, Desert County"
                                                        value={values.taxLegalDescription}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={<ErrorMessage name="taxLegalDescription" />}
                                                        error={touched.taxLegalDescription && Boolean(errors.taxLegalDescription)}
                                                        sx={{ width: '100%' }}
                                                        multiline
                                                        rows={4}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                        )}
                        {role === roles.ADMIN && (
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        color: '#919191',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        lineHeight: 'normal',
                                        textTransform: 'capitalize',
                                        mb: 2
                                    }}
                                >
                                    Parcels Delivery Information
                                </Typography>
                                <SubCard>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl fullWidth required error={touched.mlsArea && Boolean(errors.mlsArea)}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                MLS Area
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.mlsArea?.title}
                                                            ruleHelp={tips?.mlsArea?.ruleHelp}
                                                            generalHelpDesc={tips?.mlsArea?.generalHelpDesc}
                                                            sx={{ ml: 1 }}
                                                        />
                                                    </Box>

                                                    <Field
                                                        as={TextField}
                                                        name="mlsArea"
                                                        variant="outlined"
                                                        value={values.mlsArea}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={<ErrorMessage name="mlsArea" />}
                                                        error={touched.mlsArea && Boolean(errors.mlsArea)}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                    error={touched.parcelNumber && Boolean(errors.parcelNumber)}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Parcel Number (PID)
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.pid?.title}
                                                            ruleHelp={tips?.pid?.ruleHelp}
                                                            generalHelpDesc={tips?.pid?.generalHelpDesc}
                                                            generalHelp={tips?.pid?.generalHelp}
                                                            sx={{ ml: 1 }}
                                                        />
                                                    </Box>

                                                    <Field
                                                        as={TextField}
                                                        name="parcelNumber"
                                                        variant="outlined"
                                                        value={values.parcelNumber}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={<ErrorMessage name="parcelNumber" />}
                                                        error={touched.parcelNumber && Boolean(errors.parcelNumber)}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                        )}

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Additional Information
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    {role === roles.ADMIN && (
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl fullWidth required error={touched.latitude && Boolean(errors.latitude)}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Latitude
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips.latitude.title}
                                                            ruleHelp={tips.latitude.ruleHelp}
                                                            generalHelpDesc={tips.latitude.generalHelpDesc}
                                                            sx={{ ml: 1 }}
                                                        />
                                                    </Box>

                                                    <Field
                                                        as={TextField}
                                                        name="latitude"
                                                        variant="outlined"
                                                        value={values.latitude}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={<ErrorMessage name="latitude" />}
                                                        error={touched.latitude && Boolean(errors.latitude)}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    )}

                                    {role === roles.ADMIN && (
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl fullWidth required error={touched.longitude && Boolean(errors.longitude)}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Longitude
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips.longitude.title}
                                                            ruleHelp={tips.longitude.ruleHelp}
                                                            generalHelpDesc={tips.longitude.generalHelpDesc}
                                                            sx={{ ml: 1 }}
                                                        />
                                                    </Box>

                                                    <Field
                                                        as={TextField}
                                                        name="longitude"
                                                        variant="outlined"
                                                        value={values.longitude}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={<ErrorMessage name="longitude" />}
                                                        error={touched.longitude && Boolean(errors.longitude)}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    )}

                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth required error={touched.femaFloodPlain && Boolean(errors.femaFloodPlain)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        FEMA Flood Plain
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips.femaFlood.title}
                                                    ruleHelp={tips.femaFlood.ruleHelp}
                                                    generalHelpDesc={tips.femaFlood.generalHelpDesc}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Autocomplete
                                                    multiple
                                                    fullWidth
                                                    disableCloseOnSelect
                                                    options={femaFloodPlainOptions}
                                                    value={values.femaFloodPlain}
                                                    onChange={(event, newValue) => {
                                                        setFieldValue('femaFloodPlain', newValue);
                                                    }}
                                                    renderTags={(tagValue, getTagProps) =>
                                                        tagValue.map((option, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={option}
                                                                {...getTagProps({ index })}
                                                                sx={{
                                                                    '& .MuiChip-deleteIcon': {
                                                                        color: 'black !important'
                                                                    }
                                                                }}
                                                            />
                                                        ))
                                                    }
                                                    onBlur={handleBlur}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                    renderOption={(props, option, { selected }) => (
                                                        <li {...props}>
                                                            <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                            {option}
                                                        </li>
                                                    )}
                                                />
                                            </Box>
                                            {touched.femaFloodPlain && errors.femaFloodPlain && (
                                                <FormHelperText>{errors.femaFloodPlain}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        color: '#919191',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        lineHeight: 'normal',
                                        textTransform: 'capitalize',
                                        mb: 2
                                    }}
                                >
                                    School Information
                                </Typography>
                                <SubCard>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl
                                                    component="fieldset"
                                                    fullWidth
                                                    required
                                                    error={touched.county && Boolean(errors.county)}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel
                                                            component="legend"
                                                            sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}
                                                        >
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                County
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.county?.title}
                                                            ruleHelp={tips?.county?.ruleHelp}
                                                            generalHelpDesc={tips?.county?.generalHelpDesc}
                                                            sx={{ ml: 1 }}
                                                        />
                                                    </Box>

                                                    <RadioGroup
                                                        sx={{ ml: 1 }}
                                                        row
                                                        id="county"
                                                        name="county"
                                                        value={values.county}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                            setFieldValue('schoolDistrict', '');
                                                            setFieldValue('elementary', '');
                                                            setFieldValue('middleJunior', '');
                                                            setFieldValue('highSchool', '');
                                                        }}
                                                        onBlur={handleBlur}
                                                    >
                                                        {countyList.map((option) => (
                                                            <FormControlLabel
                                                                key={option}
                                                                value={option}
                                                                control={<Radio />}
                                                                label={option}
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 24px'
                                                                }}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                    {touched.county && errors.county && <FormHelperText>{errors.county}</FormHelperText>}
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                required
                                                error={touched.schoolDistrict && Boolean(errors.schoolDistrict)}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            School District
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips.schoolDistrict.title}
                                                        ruleHelp={tips.schoolDistrict.ruleHelp}
                                                        generalHelpDesc={tips.schoolDistrict.generalHelpDesc}
                                                        sx={{ ml: 1 }}
                                                    />
                                                </Box>
                                                <Autocomplete
                                                    id="schoolDistrict"
                                                    name="schoolDistrict"
                                                    fullWidth
                                                    options={[
                                                        ...new Set(
                                                            schoolData?.filter((e) => e?.County === values?.county)?.map((e) => e?.district)
                                                        )
                                                    ]}
                                                    value={values.schoolDistrict}
                                                    onChange={(event, newValue) => {
                                                        setFieldValue('schoolDistrict', newValue);
                                                        setFieldValue('elementary', '');
                                                        setFieldValue('middleJunior', '');
                                                        setFieldValue('highSchool', '');
                                                    }}
                                                    onBlur={handleBlur}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                />
                                                {touched.schoolDistrict && errors.schoolDistrict && (
                                                    <FormHelperText>{errors.schoolDistrict}</FormHelperText>
                                                )}
                                                {values?.county === '' && (
                                                    <Typography variant="caption" color="textSecondary">
                                                        Note: Please select a county to retrieve the corresponding school data.
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <FormControl fullWidth required error={touched.elementary && Boolean(errors.elementary)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span" sx={{ mb: 1 }}>
                                                            Elementary
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.elementary?.title}
                                                        ruleHelp={tips?.elementary?.ruleHelp}
                                                        generalHelpDesc={tips?.elementary?.generalHelpDesc}
                                                        sx={{ ml: 1 }}
                                                    />
                                                </Box>
                                                <Autocomplete
                                                    id="elementary"
                                                    name="elementary"
                                                    fullWidth
                                                    options={[
                                                        ...new Set(
                                                            schoolData
                                                                ?.filter(
                                                                    (e) =>
                                                                        e?.County === values?.county &&
                                                                        e?.district === values?.schoolDistrict &&
                                                                        e?.level === 'Elementary'
                                                                )
                                                                ?.map((e) => e?.name)
                                                        )
                                                    ]}
                                                    value={values.elementary}
                                                    onChange={(event, newValue) => setFieldValue('elementary', newValue)}
                                                    onBlur={handleBlur}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                />
                                                {touched.elementary && errors.elementary && (
                                                    <FormHelperText>{errors.elementary}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <FormControl fullWidth required error={touched.middleJunior && Boolean(errors.middleJunior)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span" sx={{ mb: 1 }}>
                                                            Middle or Junior
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.middleoRJunior?.title}
                                                        ruleHelp={tips?.middleoRJunior?.ruleHelp}
                                                        generalHelpDesc={tips?.middleoRJunior?.generalHelpDesc}
                                                        sx={{ ml: 1 }}
                                                    />
                                                </Box>
                                                <Autocomplete
                                                    id="middleJunior"
                                                    name="middleJunior"
                                                    fullWidth
                                                    options={[
                                                        ...new Set(
                                                            schoolData
                                                                ?.filter(
                                                                    (e) =>
                                                                        e?.County === values?.county &&
                                                                        e?.district === values?.schoolDistrict &&
                                                                        e?.level === 'Middle or Junior'
                                                                )
                                                                ?.map((e) => e?.name)
                                                        )
                                                    ]}
                                                    value={values.middleJunior}
                                                    onChange={(event, newValue) => setFieldValue('middleJunior', newValue)}
                                                    onBlur={handleBlur}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                />
                                                {touched.middleJunior && errors.middleJunior && (
                                                    <FormHelperText>{errors.middleJunior}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <FormControl fullWidth required error={touched.highSchool && Boolean(errors.highSchool)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span" sx={{ mb: 1 }}>
                                                            High School
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.highSchool?.title}
                                                        ruleHelp={tips?.highSchool?.ruleHelp}
                                                        generalHelpDesc={tips?.highSchool?.generalHelpDesc}
                                                        sx={{ ml: 1 }}
                                                    />
                                                </Box>
                                                <Autocomplete
                                                    id="highSchool"
                                                    name="highSchool"
                                                    fullWidth
                                                    options={[
                                                        ...new Set(
                                                            schoolData
                                                                ?.filter(
                                                                    (e) =>
                                                                        e?.County === values?.county &&
                                                                        e?.district === values?.schoolDistrict &&
                                                                        e?.level === 'High School'
                                                                )
                                                                ?.map((e) => e?.name)
                                                        )
                                                    ]}
                                                    value={values.highSchool}
                                                    onChange={(event, newValue) => setFieldValue('highSchool', newValue)}
                                                    onBlur={handleBlur}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                />
                                                {touched.highSchool && errors.highSchool && (
                                                    <FormHelperText>{errors.highSchool}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    {/* <Grid item xs={12} sx={{ mt: 2 }}>
                                <SubCard title="Elementary">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth required error={touched.elementary && Boolean(errors.elementary)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Box sx={{ flex: 1 }}>
                                                        <InputLabel>Elementary</InputLabel>
                                                        <Select
                                                            id="elementary"
                                                            name="elementary"
                                                            label="Elementary"
                                                            value={values.elementary}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            fullWidth // This ensures the Select takes up the full width
                                                            input={<OutlinedInput label="Elementary" />}
                                                        >
                                                            {elementaryOptions.map((option) => (
                                                                <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                                    <ListItemText primary={option} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                    <HelpIcon
                                                        title={tips.elementarySchool.title}
                                                        ruleHelp={tips.elementarySchool.ruleHelp}
                                                        generalHelpDesc={tips.elementarySchool.generalHelpDesc}
                                                    />
                                                </Box>
                                                {touched.elementary && errors.elementary && (
                                                    <FormHelperText>{errors.elementary}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Elementary Other"
                                                name="elementaryOther"
                                                value={values.elementaryOther}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {touched.elementaryOther && errors.elementaryOther && (
                                                <FormHelperText error>{errors.elementaryOther}</FormHelperText>
                                            )}
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid> */}

                                    {/* <Grid item xs={12} sx={{ mt: 2 }}>
                                <SubCard title="Middle or Junior">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth required error={touched.middleJunior && Boolean(errors.middleJunior)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Box sx={{ flex: 1 }}>
                                                        <InputLabel>Middle or Junior</InputLabel>
                                                        <Select
                                                            id="middleJunior"
                                                            name="middleJunior"
                                                            label="Middle or Junior"
                                                            value={values.middleJunior}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            fullWidth // This ensures the Select takes up the full width
                                                            input={<OutlinedInput label="Middle or Junior" />}
                                                        >
                                                            {middleJuniorOptions.map((option) => (
                                                                <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                                    <ListItemText primary={option} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                    <HelpIcon
                                                        title={tips.middleoRJunior.title}
                                                        ruleHelp={tips.middleoRJunior.ruleHelp}
                                                        generalHelpDesc={tips.middleoRJunior.generalHelpDesc}
                                                    />
                                                </Box>
                                                {touched.middleJunior && errors.middleJunior && (
                                                    <FormHelperText>{errors.middleJunior}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Middle or Junior Other"
                                                name="middleJuniorOther"
                                                value={values.middleJuniorOther}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {touched.middleJuniorOther && errors.middleJuniorOther && (
                                                <FormHelperText error>{errors.middleJuniorOther}</FormHelperText>
                                            )}
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid> */}
                                    {/* <Grid item xs={12} sx={{ mt: 2 }}>
                                <SubCard title="High School">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth required error={touched.highSchool && Boolean(errors.highSchool)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Box sx={{ flex: 1 }}>
                                                        <InputLabel>High School</InputLabel>
                                                        <Select
                                                            id="highSchool"
                                                            name="highSchool"
                                                            label="High School"
                                                            value={values.highSchool}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            fullWidth // This ensures the Select takes up the full width
                                                            input={<OutlinedInput label="High School" />}
                                                        >
                                                            {highSchoolOptions.map((option) => (
                                                                <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                                    <ListItemText primary={option} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                    <HelpIcon
                                                        title={tips.highSchool.title}
                                                        ruleHelp={tips.highSchool.ruleHelp}
                                                        generalHelpDesc={tips.highSchool.generalHelpDesc}
                                                    />
                                                </Box>

                                                {touched.highSchool && errors.highSchool && (
                                                    <FormHelperText>{errors.highSchool}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="High School Other"
                                                name="highSchoolOther"
                                                value={values.highSchoolOther}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {touched.highSchoolOther && errors.highSchoolOther && (
                                                <FormHelperText error>{errors.highSchoolOther}</FormHelperText>
                                            )}
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid> */}
                                </SubCard>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        mb: 2,
                                        p: 1,
                                        background: 'white'
                                    }}
                                    onClick={handleToggle}
                                >
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            textTransform: 'capitalize'
                                        }}
                                    >
                                        Optional Information
                                    </Typography>
                                    <IconButton>{openOptional ? <ExpandLess /> : <ExpandMore />}</IconButton>
                                </Box>
                                <Collapse in={openOptional}>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormControl fullWidth error={touched.taxLot && Boolean(errors.taxLot)}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Tax Lot
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.taxLot?.title}
                                                                ruleHelp={tips?.taxLot?.ruleHelp}
                                                                generalHelpDesc={tips?.taxLot?.generalHelpDesc}
                                                                sx={{ ml: 1 }}
                                                            />
                                                        </Box>

                                                        <TextField
                                                            name="taxLot"
                                                            value={values.taxLot}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    </FormControl>
                                                </Box>
                                                {touched.taxLot && errors.taxLot && <FormHelperText error>{errors.taxLot}</FormHelperText>}
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormControl fullWidth error={touched.taxBlock && Boolean(errors.taxBlock)}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Tax Block
                                                                </Typography>
                                                            </FormLabel>

                                                            <HelpIcon
                                                                title={tips?.taxBlock?.title}
                                                                ruleHelp={tips?.taxBlock?.ruleHelp}
                                                                generalHelpDesc={tips?.taxBlock?.generalHelpDesc}
                                                                sx={{ ml: 1 }}
                                                            />
                                                        </Box>

                                                        <TextField
                                                            name="taxBlock"
                                                            value={values.taxBlock}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    </FormControl>
                                                </Box>
                                                {touched.taxBlock && errors.taxBlock && (
                                                    <FormHelperText error>{errors.taxBlock}</FormHelperText>
                                                )}
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <FormControl
                                                        fullWidth
                                                        error={touched.streetDirPrefix && Boolean(errors.streetDirPrefix)}
                                                    >
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Street Dir Prefix
                                                                </Typography>
                                                            </FormLabel>

                                                            <HelpIcon
                                                                title={tips?.streetDirPrefix?.title}
                                                                ruleHelp={tips?.streetDirPrefix?.ruleHelp}
                                                                generalHelpDesc={tips?.streetDirPrefix?.generalHelpDesc}
                                                                sx={{ ml: 1 }}
                                                            />
                                                        </Box>

                                                        <TextField
                                                            inputRef={inputFocusRef}
                                                            name="streetDirPrefix"
                                                            value={values.streetDirPrefix}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={touched.streetDirPrefix && Boolean(errors.streetDirPrefix)}
                                                        />
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                            {role === roles.ADMIN && (
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth error={touched.etj && Boolean(errors.etj)}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    ETJ
                                                                </Typography>
                                                            </FormLabel>

                                                            <HelpIcon
                                                                title={tips.etj.title}
                                                                ruleHelp={tips.etj.ruleHelp}
                                                                generalHelpDesc={tips.etj.generalHelpDesc}
                                                                sx={{ ml: 1 }}
                                                            />
                                                        </Box>

                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Select
                                                                name="etj"
                                                                value={values.etj}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                fullWidth
                                                            >
                                                                <MenuItem value="YES">YES</MenuItem>
                                                                <MenuItem value="NO">NO</MenuItem>
                                                                <MenuItem value="See Remarks">See Remarks</MenuItem>
                                                            </Select>
                                                        </Box>
                                                        {touched.etj && errors.etj && <FormHelperText>{errors.etj}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </SubCard>
                                </Collapse>
                            </Grid>
                        </Grid>
                    </Grid>

                    {errors.submit && (
                        <Grid item xs={12}>
                            <FormHelperText error>{errors.submit}</FormHelperText>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default Listing;
